import { CartV2, OrderV2, OrderDataV2, StoreV2 } from '@occ/api-client';

const orderApi = new OrderV2({ baseUrl: '' });
const cartApi = new CartV2({ baseUrl: '' });
const storeApi = new StoreV2({ baseUrl: '' });

export const cancelOrder = (orderID: string) => orderApi.cancelOrderV2(orderID);

export interface OrderDataV2WithOrderNumber extends OrderDataV2 {
  orderNumber: string;
  purchaseRegrettable?: boolean;
}

export const getOrder = async (orderId: string) => {
  const response = await orderApi.getFullOrderDataV2({ q: orderId });
  return response.data as OrderDataV2WithOrderNumber;
};

export const getOrderStatus = async (orderID: string) => {
  const response = await orderApi.validateOrderEntriesV2(orderID, {});
  return response.data;
};

export const getComplaintOrders = async () => {
  const response = await orderApi.getOrdersForComplaintV2();
  return response.data;
};

export const isNearLockers = (storeId: string, latitude: number, longitude: number) =>
  storeApi.isPointCloseToStoreV2(storeId, { latitude, longitude });

export const startChangingOrder = (orderID?: string) => cartApi.continueShopForOrderV2({ orderNumber: orderID! });

export const getOrderProcess = (orderID: string) => orderApi.isOrderProcessFinishedV2(orderID);

export const startCollectOrderProcess = async (orderCode: string) => {
  const response = await orderApi.startCollectProcessV2(orderCode);
  return response.data;
};

export const unlockOrderBox = async (orderCode: string, boxId: string, previousOpened: { previousOpened: string }) => {
  const response = await orderApi.unlockOrderBoxV2(boxId, orderCode, previousOpened);
  return response.data;
};

export const finishCollectProcess = async (orderCode: string) => {
  const response = await orderApi.finishCollectProcessV2(orderCode);
  return response.data;
};
